import React from 'react';

/**
 * エラーバウンダリ - アプリ全体のクラッシュを防止
 * 子コンポーネントでエラーが発生した場合、フォールバックUIを表示
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // 本番環境ではエラー追跡サービスに送信（将来実装）
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.hash = '';
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.hash = '';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-content">
            <div className="error-icon">⚠️</div>
            <h1 className="error-title">エラーが発生しました</h1>
            <p className="error-message">
              申し訳ありません。予期しないエラーが発生しました。
            </p>
            <div className="error-actions">
              <button
                className="cyber-btn cyber-btn-primary"
                onClick={this.handleGoHome}
              >
                ホームに戻る
              </button>
              <button
                className="cyber-btn cyber-btn-secondary"
                onClick={this.handleReload}
              >
                ページを再読み込み
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details">
                <summary>エラー詳細（開発モード）</summary>
                <pre>{this.state.error.toString()}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
